module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam05-d9ef5de2a899fefadd490abe9070ce37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/19132-EXT1-Cam05.jpg
// module id = 746
// module chunks = 0